import nergyLogo from "../../assets/img/360logoVidya.svg";
import { useOpenBookScopeContext } from "..";

export const Header = () => {
  const { openBookState } = useOpenBookScopeContext();
  const { taskName, taskTitle } = openBookState;

  return (
    <>
      <header className="main-header">
        <div className="container">
          <div className="head-wrap">
            <div className="header-content w-100 d-flex align-items-center justify-content-between">
              <div className="header-left d-flex align-items-center justify-content-between">
                <a href="/">
                  <img src={nergyLogo} alt="nergy vidya" />
                </a>
                {taskName && (
                  <div className="header-badge d-none d-md-block" name="title">
                    {taskName}
                  </div>
                )}
              </div>
              {taskTitle && (
                <div className="header-right">
                  <div className="header-badge" name="taskName">
                    <span>
                      Question No <strong>{taskTitle}</strong>
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
